import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Link } from '@spotify-internal/encore-web';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import { TransitionScreen } from '../TransitionScreen';
import { XirpEmailVerifiedPage } from './Xirp';

const XIRP_APP_NAME = 'xirp';

const EmailVerifiedPageComponent = () => {
  return (
    <TransitionScreen
      title="Email verified"
      description="Your email has been verified. You can close this tab and return to the signup window."
      helperText={
        <>
          Closed your signup window?{' '}
          <Link href="/signup?verified=true" data-track-source-anchor="018e835b5a">Continue here</Link>
        </>
      }
    />
  );
};

export const EmailVerifiedPage = withPageImpression(
  EmailVerifiedPageComponent,
  { pageId: 'email-verified' },
);

export const EmailVerifiedRoute = (): ReactElement => {
  const [searchParams] = useSearchParams();
  const appParam = searchParams.get('app');

  if (appParam?.toLowerCase() === XIRP_APP_NAME) {
    return <XirpEmailVerifiedPage />;
  }

  return <EmailVerifiedPage />;
};
